import lang from '@/lang'
import React from 'react'
import { Route } from 'react-router'

const TransactionSendEmail = React.lazy(() => import('@/modules/transaction/components/email/transaction-send-email'))
const DeliveryNoteList = React.lazy(() => import('@/modules/deliveryNote/list/deliveryNote-list'))
const DeliveryNoteEditView = React.lazy(() => import('@/modules/deliveryNote/deliveryNote-edit-view'))
const DeliveryNoteDetail = React.lazy(() => import('@/modules/deliveryNote/detail/deliveryNote-detail'))
const RedirectToPlural = React.lazy(() => import('@/modules/layout/util/redirectToPlural'))

const deliveryNoteRoutes = (
  <>
    <Route path='deliverynote/*' element={<RedirectToPlural />} />
    <Route path='deliverynotes' Component={DeliveryNoteList} handle={{ title: lang.deliveryNote.deliveryNote, options: { noBackgroundColor: true } }} />
    <Route path='deliverynotes/new' Component={DeliveryNoteEditView} />
    <Route path='deliverynotes/send/:id' Component={TransactionSendEmail} handle={{ options: { noBackgroundColor: true } }} />
    <Route path='deliverynotes/edit/:id' Component={DeliveryNoteEditView} />
    <Route path='deliverynotes/new/customer/:customerId' Component={DeliveryNoteEditView} />
    <Route path='deliverynotes/:id' Component={DeliveryNoteDetail} />
  </>
)

export default deliveryNoteRoutes
